export class DeadlineRule {
  param: string;
  paramType: string;
  template: string;
  description?: string;
}
